import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/pages/HomePage";
import Locations from "./components/owner/OwnerLocations";
import FerienparkHahnenklee from "./components/pages/FerienparkHahnenklee";
import Apartments from "./components/pages/Apartments";
import Booking from "./components/pages/Booking";
import Login from "./components/pages/Login";
import ForgotPassword from "./components/pages/ForgotPassword";
import ResetPassword from "./components/pages/ResetPassword";
import NavBar from "./components/common/NavBar";
import Register from "./components/pages/Register"
import OwnerDashboard from "./components/owner/OwnerDashboard";
import OwnerProfile from "./components/owner/OwnerProfile"; // ✅ Correct import
import EmailSender from "./components/owner/EmailSender"; // ✅ Correct import
import OwnerGuests from './components/owner/OwnerGuests';
import BookingManagement from './components/owner/booking-management/BookingManagement';
import OwnerReviews from './components/owner/OwnerReviews'; // Import the OwnerReviews component
import Currencies from "./components/owner/Currencies";
import OwnerCosts from "./components/owner/OwnerCosts";
import Facilities from "./components/owner/Facilities";
import GuestDashboard from "./components/guests/GuestDashboard";
import GuestProfile from "./components/guests/GuestProfile"; // ✅ Correct import
import GuestsBookings from './components/guests/GuestsBookings'; // Import the OwnerBookings component
import GuestReviews from './components/guests/GuestReviews'; // Import the OwnerReviews component
import ContactUs from "./components/pages/ContactUs";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsConditions from "./components/pages/TermsConditions";
import DataDeletionRequest from "./components/pages/DataDeletionRequest";
import ApartmentDetails from './components/pages/ApartmentDetails';
import ApartmentReviews from './components/pages/ApartmentReviews';
import NotFound from './components/pages/NotFound';
import BlogList from './components/pages/BlogList';
import BlogDetail from './components/pages/BlogDetail';
import OwnerBlog from './components/owner/OwnerBlog';
import OwnerBlogForm from './components/owner/OwnerBlogForm';
import ProtectedRoute from './components/common/ProtectedRoute';
import ChatWidget from './components/common/ChatWidget';


const AppRoutes = () => {
  return (
    <Router>
      <NavBar /> {/* Common menu used on all pages */}
      <ChatWidget /> {/* Floating AI chat widget, present on every page */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/ferienpark-hahnenklee" element={<FerienparkHahnenklee />} />
        <Route path="/apartments" element={<Apartments />} />
        <Route path="/apartments/:id" element={<ApartmentDetails />} />
        <Route path="/apartments/:id/reviews" element={<ApartmentReviews />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />  {/* Ensure this exists */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/owner/dashboard" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />
        <Route path="/owner/profile" element={<ProtectedRoute><OwnerProfile /></ProtectedRoute>} />
        <Route path="/owner/emailsender" element={<ProtectedRoute><EmailSender /></ProtectedRoute>} />
        <Route path="/owner/apartments" element={<ProtectedRoute><Apartments /></ProtectedRoute>} />
        <Route path="/owner/guests" element={<ProtectedRoute><OwnerGuests /></ProtectedRoute>} />
        <Route path="/owner/bookings" element={<ProtectedRoute><BookingManagement /></ProtectedRoute>} /> {/* Add the OwnerBookings route */}
        <Route path="/owner/reviews" element={<ProtectedRoute><OwnerReviews /></ProtectedRoute>} /> {/* Add the OwnerReviews route */}
        <Route path="/owner/OwnerLocations" element={<ProtectedRoute><Locations /></ProtectedRoute>} />
        <Route path="/owner/currencies" element={<ProtectedRoute><Currencies /></ProtectedRoute>} />
        <Route path="/owner/costs" element={<ProtectedRoute><OwnerCosts /></ProtectedRoute>} />
        <Route path="/owner/Facilities" element={<ProtectedRoute><Facilities /></ProtectedRoute>} />
        <Route path="/guest/dashboard" element={<ProtectedRoute><GuestDashboard /></ProtectedRoute>} />
        <Route path="/guest/profile" element={<ProtectedRoute><GuestProfile /></ProtectedRoute>} />
        <Route path="/guest/bookings" element={<ProtectedRoute><GuestsBookings /></ProtectedRoute>} />
        <Route path="/guest/reviews" element={<ProtectedRoute><GuestReviews /></ProtectedRoute>} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
        <Route path="/condiciones-del-servicio" element={<TermsConditions />} />
        <Route path="/solicitud-eliminacion-datos" element={<DataDeletionRequest />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/owner/blog" element={<ProtectedRoute><OwnerBlog /></ProtectedRoute>} />
        <Route path="/owner/blog/new" element={<ProtectedRoute><OwnerBlogForm /></ProtectedRoute>} />
        <Route path="/owner/blog/:slug/edit" element={<ProtectedRoute><OwnerBlogForm /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} /> {/* Catch-all route for 404 page */}

      </Routes>
    </Router>
  );
};

export default AppRoutes;

